import { CommonHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const getNewClubRegistrationData = (state, setState, isRevisit) => {
  if (state.isArrayLoading !== true && !state.message) {
    let newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const isRevisitForUrl = isRevisit === true ? true : false;
    const url = `/Workflow/NewClubRegistration/0?isRevisit=${isRevisitForUrl}`;
    CommonHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  };
};

export default getNewClubRegistrationData;